import { motion } from "framer-motion";
import { ImageIcon } from "lucide-react";

export default function Projects() {
  return (
    <section
      id="projects"
      data-testid="projects-section"
      className="section-pad"
    >
      <div className="container-outer">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <p className="overline mb-4">Selected work</p>
            <h2 className="font-heading text-4xl sm:text-5xl font-medium text-primary heading-tight">
              Case studies coming soon.
            </h2>
          </div>
          <p className="text-muted-foreground text-base md:max-w-sm">
            We are curating project photography and performance data from our
            recent deployments. Detailed case studies will be published shortly.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7 }}
          className="relative overflow-hidden rounded-lg border border-border bg-secondary/40"
          data-testid="projects-coming-soon"
        >
          <div
            className="relative flex flex-col items-center justify-center text-center px-6 py-24 md:py-36"
            style={{
              backgroundImage:
                "repeating-linear-gradient(45deg, hsl(var(--border)/0.35) 0 1px, transparent 1px 22px)",
            }}
          >
            <div className="h-16 w-16 rounded-full bg-surface border border-border flex items-center justify-center mb-6">
              <ImageIcon size={22} strokeWidth={1.5} className="text-primary" />
            </div>
            <p className="overline mb-3">Image coming soon</p>
            <h3 className="font-heading text-3xl md:text-4xl font-medium text-primary heading-tight max-w-xl">
              Our project gallery is being prepared.
            </h3>
            <p className="mt-4 text-muted-foreground max-w-lg leading-relaxed">
              Check back soon — or get in touch and we will share relevant
              project references directly with you.
            </p>
            <a
              href="#contact"
              data-testid="projects-contact-link"
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-primary text-primary-foreground px-6 h-11 text-sm font-medium hover:bg-primary/90 transition-all hover:-translate-y-0.5"
            >
              Request project references
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
